import React from "react";
import { useTranslation } from "react-i18next";

function ContactFormSubmissions()
{
    var { t } = useTranslation();

    // Хранилище данных с бэкенда
    const [dataSource, setDataSource] = React.useState([]);

    // Состояние сортировки: какая колонка и направление
    const [sortState, setSortState] = React.useState({ column: null, direction: null });

    // Управление видимостью колонки Email
    const [emailHidden, setEmailHidden] = React.useState(false);

    // Получение токена из localStorage для авторизации на сервере
    const token = window.localStorage.getItem("token");

    // Состояние ошибки при отсутствии токена
    const [noToken, setNoToken] = React.useState(false);

    // Получение данных с сервера
    function fetchData()
    {
        if (!token) return;

        fetch("https://api.jai.com.kz/api/applications",
        {
            method: "GET",
            headers:
            {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        })
        .then(function(response)
        {
            if (!response.ok)
            {
                throw new Error("HTTP error " + response.status);
            }
            return response.json();
        })
        .then(function(data)
        {
            if (data && Array.isArray(data.applications))
            {
                setDataSource(data.applications);
            }
            else
            {
                console.warn("Unexpected response format, expected { applications: [...] }:", data);
            }
        })
        .catch(function(error)
        {
            console.error("Error fetching contact forms:", error);
        });
    }

    // useEffect вызывается всегда, но внутри проверяем токен
    React.useEffect(function()
    {
        if (!token)
        {
            setNoToken(true);
        }
        else
        {
            fetchData();
        }
    }, [token]);

    // Сортировка данных по колонке
    function handleSort(column)
    {
        setSortState(function(prev)
        {
            let newDirection;

            if (prev.column !== column) newDirection = "asc";
            else if (prev.direction === "asc") newDirection = "desc";
            else if (prev.direction === "desc") newDirection = null;
            else newDirection = "asc";

            return { column, direction: newDirection };
        });
    }

    // Данные после сортировки
    const displayedData = React.useMemo(function()
    {
        if (!sortState.column || !sortState.direction) return dataSource;

        const sorted = [...dataSource];
        sorted.sort(function(a, b)
        {
            const valA = (a[sortState.column] || "").toString().toLowerCase();
            const valB = (b[sortState.column] || "").toString().toLowerCase();

            if (valA < valB) return sortState.direction === "asc" ? -1 : 1;
            if (valA > valB) return sortState.direction === "asc" ? 1 : -1;
            return 0;
        });
        return sorted;
    }, [dataSource, sortState]);

    // Очистка всех запросов / сообщений
    function flushInquiries()
    {
        console.log("Flush inquiries placeholder");
        // Здесь можно добавить fetch с DELETE или POST для удаления
    }

    return (
        <div className="uk-container uk-margin-large-top">
            {noToken &&
                <div>{t("ui.admin.token_missing")}</div>
            }

            {!noToken &&
                <>
                    <h1>
                        {t("ui.admin.contact_requests")}
                    </h1>

                    <button className="uk-button" onClick={flushInquiries}>
                        {t("ui.button.delete") || "Delete all"}
                    </button>

                    <table className="uk-table uk-table-divider uk-table-hover uk-table-small">
                        <thead>
                            <tr>
                                <th onClick={function() { handleSort("name"); }}>
                                    {t("ui.admin.fullname")} 
                                </th>
                                <th onClick={function() { setEmailHidden(function(prev) { return !prev; }); }}>
                                    {t("ui.admin.email")}
                                </th>
                                <th onClick={function() { handleSort("phone"); }}>
                                    {t("ui.admin.phone")}
                                </th>
                                <th onClick={function() { handleSort("text"); }}>
                                    {t("ui.admin.inquiry")}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedData.map(function(item, index)
                            {
                                return (
                                    <tr key={index}>
                                        <td>{item.name}</td>
                                        {!emailHidden &&
                                            <td>
                                                <a href={"mailto:" + item.email}>{item.email}</a>
                                            </td>
                                        }
                                        <td>
                                            <a
                                                href={"https://wa.me/" + item.phone.replace(/\D/g, "")}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {item.phone}
                                            </a>
                                        </td>
                                        <td>{item.text}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            }
        </div>
    );
}

export default ContactFormSubmissions;
